<template>
  <div>
    <v-alert
      v-if="ShowErrorMessage && !mandatoryFieldCompiled"
      color="red darken-4"
      dark
      icon="mdi-alert-octagon-outline"
      dense
    >
      Seleziona un cliente
    </v-alert>
    <v-row>
      <v-col cols="10">
        <v-combobox
          v-model="cliente"
          label="Cliente"
          outlined
          :items="clients"
          item-text="descrizione"
        >
        </v-combobox>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="smokewhite"
          class="addCliente"
          @click.stop="btnAddCustomer_Click"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="10">
        <v-combobox
          v-model.lazy="eventInfo.indirizzoCompleto"
          label="Sede cantiere"
          name="sede"
          variant="outlined"
          outlined
          ref="txtSede"
          :hide-no-data="true"
          type="text"
          @change="sede_Change"
          @input="sede_Input"
          @keyup="sede_KeyUp"
          class="mb-9"
          :items="sedi"
          item-text="indirizzoCompleto"
        >
        </v-combobox>
      </v-col>

      <v-col cols="2">
        <v-btn
          color="smokewhite"
          class="addCliente"
          v-bind:disabled="eventInfo.idCliente == undefined"
          @click.stop="btnAddHeadquarter_Click"
        >
          <v-icon dark> mdi-plus </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" v-if="updateComponents && updateMap > 0">
        <!-- {{updateComponents}} -->
        <Map
          v-bind:indirizzo="eventInfo.indirizzoCompleto"
          :updateComponent="updateMap"
          citta=""
        ></Map>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <FrmEditCustomer
          ref="frmCustomer"
          v-bind:clientInfo="this.clientInfo"
          v-bind:eventInfo="this.eventInfo"
          v-on:close-dialog="closeDialog"
          v-on:customerAdded="customer_Added"
        ></FrmEditCustomer>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="blue darken-1" text @click="frmEditCustomerSave_Click">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogHeadquarter" persistent max-width="600px">
      <v-card>
        <FrmEditHeadquarter
          ref="frmEditHeadquarter"
          v-bind:headquarterDetails="headquarterDetails"
          v-on:headquarterAdded="headquarter_Added"
        ></FrmEditHeadquarter>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogHeadquarter = false">
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="frmEditHeadqurterSave_Click"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EasyPlanClient from "../../../utils/EasyPlanClient";
import FrmEditCustomer from "../../EditForms/FrmEditCustomer";
import FrmEditHeadquarter from "../../EditForms/FrmEditHeadquarter";
import Map from "../../CustomComponentsUI/Map";
export default {
  components: { FrmEditCustomer, FrmEditHeadquarter, Map },
  props: ["eventInfo", "updateComponents"],

  watch: {
    updateComponents: function (val) {
      if (
        this.eventInfo.idCliente != undefined &&
        this.eventInfo.idCliente != null
      ) {
        this.loadCustomers(() => {
          this.loadHeadquarters(this.eventInfo.idCliente, () => {
            console.debug(
              "updateComponents updated this.clients",
              this.clients
            );
            console.debug(
              "updateComponents updated this.eventInfo.idCliente",
              this.eventInfo.idCliente
            );
            this.clientInfo = this.clients.find(
              (c) => c.idCliente == this.eventInfo.idCliente
            );
            if(this.clientInfo==undefined)
            this.clientInfo=null;
            this.eventInfo.cliente = this.clientInfo;
            console.debug(
              "updateComponents updated  this.clientInfo",
              this.clientInfo
            );
            // if(val.indirizzoCompleto)
            //   this.addressvalue=val.indirizzoCompleto;
            this.updateMapComponent();
            
          });
        });
      }

      this.updateMapComponent();
    },
    eventInfo: function (val) {
      console.log("eventInfo prop changed", val);
      console.log(val);
      if (val.idCliente != undefined && val.idCliente != null) {
        this.loadHeadquarters(val.idCliente, () => {
          this.updateMapComponent();
        });
        console.debug("eventInfo updated this.clients", this.clients);
        console.debug("this.eventInfo.idCliente", this.eventInfo.idCliente);
        this.clientInfo = this.clients.find(
          (c) => c.idCliente == this.eventInfo.idCliente
        );
        console.debug("eventInfo updated this.clientInfo", this.clientInfo);
        // if(val.indirizzoCompleto)
        //   this.addressvalue=val.indirizzoCompleto;
      } else {
        this.resetFormData();
      }
      if(this.eventInfo.cliente==undefined)
      this.eventInfo.cliente=null;

        this.UpdateComponents();
      this.updateMapComponent();
    },
  },
  data: () => ({
    updateMap: 1,
    searchDelay: 400,
    error: null,
    clientInfo: {
      descrizione: "",
      indirizzo: "",
      cap: "",
      città: "",
      provincia: "",
      telefono: "",
      mail: "",
      sedi: [],
    },
    name: "",
    addressvalue: "",
    Info: null,
    disabled: false,
    ShowErrorMessage: false,
    spent: 0,
    dialog: false,
    dialogHeadquarter: false,
    row: 0,
    sedeObj: undefined,
    sedi: [],
    sediItems: [],
    clients: [],
    headquarterDetails: {
      indirizzo: "",
      cap: "",
      citta: "",
      provincia: "",
    },
  }),
  mounted() {
    console.log(this.eventInfo);
    this.loadHeadquarters(this.eventInfo.idCliente);
    var cmp = this;
    cmp.spent = 0;
    //  let addr=this.addressvalue;

    setInterval(function () {
      cmp.spent += 100;

      if (cmp.spent > cmp.searchDelay) {
        cmp.spent = 0;
        if (cmp.$refs.txtSede != undefined) {
          cmp.eventInfo.indirizzoCompleto = cmp.$refs.txtSede.lazySearch;
        }

        // cmp.addressvalue=cmp.$refs.txtSede.lazySearch;
        cmp.updateMapComponent();
        // if(cmp.addressvalue!="")
        // cmp.eventInfo.indirizzoCompleto=cmp.addressvalue;
      }
    }, 100);
    // eventInfo:this.eventInfo,
  },
  created() {
    this.initialize();
  },
  computed: {
    mandatoryFieldCompiled: {
      get() {
        return Boolean(
          this.eventInfo.idCliente > 0 && this.eventInfo.indirizzoCompleto != ""
        );
      },
    },
    cliente: {
      get() {
        let cl = this.clients.find(
          (c) => c.idCliente == this.eventInfo.idCliente
        );

        if (cl == undefined && this.clients.length > 0) {
          return null;
          // cl = this.clients[0];
          // var cmpnt = this;
          // this.loadHeadquarters(cl.idCliente, (sedi) => {
          //   this.eventInfo.cliente = cmpnt.clientInfo;
          // });
        }
        if (cl == undefined) return null;
        // cl = {
        //   descrizione: null,
        //   indirizzo: "",
        //   cap: "",
        //   città: "",
        //   provincia: "",
        //   telefono: "",
        //   mail: "",
        //   sedi: [],
        // };
        console.debug("CLIENTEEE", cl);
        return cl;
      },
      set(val) {
        if (val != null) {
          this.eventInfo.idCliente = val.idCliente;
          var cmpnt = this;
          this.loadHeadquarters(val.idCliente, (sedi) => {
            cmpnt.clientInfo = cmpnt.clients.find(
              (c) => c.idCliente == val.idCliente
            );
            if (cmpnt.clientInfo == undefined)
             cmpnt.clientInfo = null;
            this.eventInfo.cliente = cmpnt.clientInfo;
            
            // if(cmpnt.cliente.IndirizzoCompletoPrincipale!="" && cmpnt.indirizzoCompleto=="")
            //   cmpnt.IndirizzoCompleto=cmpnt.cliente.IndirizzoCompletoPrincipale;
          });
        }
        else{
          this.eventInfo.idCliente=0;
          this.eventInfo.cliente=null;
        }
        this.UpdateComponents();
      },
    },

    showMap() {
      return this.eventInfo.indirizzoCompleto.length > 0;
    },
  },

  methods: {
    resetFormData() {
      console.debug("RESET STEP CUSTOMER HEADQUARTER");
      this.clientInfo = {
        descrizione: "",
        indirizzo: "",
        cap: "",
        città: "",
        provincia: "",
        telefono: "",
        mail: "",
        sedi: [],
      };
      this.sediItems = [];
      this.sedi = [];

      this.eventInfo.idCliente = 0;
      this.cliente = null;
      this.eventInfo.cliente = null;
      // let cl = this.clients.find(
      //   (c) => c.idCliente == this.eventInfo.idCliente
      // );
      // if(cl)
      // if (cl == undefined && this.clients.length > 0) {
      //   cl = this.clients[0];

      //   var cmpnt = this;
      //   this.loadHeadquarters(cl.idCliente, (sedi) => {
      //     this.eventInfo.cliente = cmpnt.clientInfo;
      //   });
      // }
    },
    UpdateComponents(){
this.updateComponents++; 
    },
    updateMapComponent() {
      if (
        this.eventInfo.indirizzoCompleto != "" &&
        this.eventInfo.indirizzoCompleto != null
      )
        this.updateMap++;
      else this.updateMap = 0;
    },
    eventHasAddress: function () {
      return this.eventInfo.indirizzoCompleto.length > 0;
    },
    isEmptyOrSpaces: function (str) {
      return str === null || str.match(/^ *$/) !== null;
    },
    CanGoFarward() {
      this.ShowErrorMessage = true;
      return this.mandatoryFieldCompiled; // > 0;
    },
    btnAddCustomer_Click() {
      this.clientInfo = {
        descrizione: "",
        indirizzo: "",
        cap: "",
        città: "",
        provincia: "",
        telefono: "",
        mail: "",
        sedi: [],
      };
      this.dialog = true;
    },
    btnAddHeadquarter_Click() {
      this.headquarterDetails = {
        indirizzo: "",
        cap: "",
        citta: "",
        provincia: "",
      };
      this.dialogHeadquarter = true;
    },
    sede_Change(val) {
      console.info("VAL sede change", val);
      this.eventInfo.indirizzoCantiere = val.indirizzo;
      this.eventInfo.cittaCantiere = val.citta;
      this.eventInfo.capCantiere = val.cap;
      this.eventInfo.provinciaCantiere = val.provincia;
      this.eventInfo.indirizzoCompleto = val.indirizzoCompleto;
      this.updateMapComponent();
    },
    sede_Input(val) {
      console.info("VAL sede input", val);
      var cmp = this;
      cmp.spent = 0;
      console.info("VAL sede input", val);
    },
    sede_KeyUp(val) {
      console.info("VAL sede input", val);
      var cmp = this;

      this.eventInfo.indirizzoCantiere = "";
      this.eventInfo.cittaCantiere = "";
      this.eventInfo.capCantiere = "";
      this.eventInfo.provinciaCantiere = "";
      cmp.spent = 0;
      //  let addr=this.addressvalue;
      this.updateMapComponent();
    },
    frmEditCustomerSave_Click: function () {
      this.$refs.frmCustomer.addClient(() => {
        this.closeDialog();
      });
    },
    customer_Added() {
      // alert("customer added")
      this.loadCustomers();
    },
    headquarter_Added(headquarter) {
      headquarter.fullAddress = this.getFullAddress(
        headquarter.indirizzo,
        headquarter.citta,
        headquarter.provincia
      );
      console.debug("headquarter", headquarter);

      this.sedi.push(headquarter);
      // this.eventInfo.indirizzoCompleto=headquarter.fullAddress;
    },
    frmEditHeadqurterSave_Click: function () {
      this.$refs.frmEditHeadquarter.save(
        this.$route.params.companyAlias,
        this.eventInfo.idCliente
      );
      this.dialogHeadquarter = false;
      // $refs.frmEditHeadquarter.save
    },
    closeDialog: function () {
      this.dialog = false;
    },
    closeHeadquarterDialog: function () {
      this.dialogHeadquarter = false;
    },
    show: function () {
      alert();
    },

    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      this.loadCustomers(() => {
        // this.clientInfo = this.clients.find(
        //   (c) => c.idCliente == this.eventInfo.idCliente
        // );
      });
    },
    getFullAddress(address, city, province) {
      let fullAddress = ""; //address + " - " + city + " (" + province + ") ";
      if (address != null) fullAddress += address;
      if (city != null) fullAddress += " - " + city;
      if (province != null) fullAddress += " (" + province + ")";

      return fullAddress;
    },

    loadCustomers(callback = () => {}) {
      console.log("loading customers...");
      this.clients = [];
      EasyPlanClient.Customers.GetAll(
        this.$route.params.companyAlias,
        this.eventInfo.idCliente
      )
        .then((res) => {
          this.clients = res.data.data;
          callback(this.clients);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    loadHeadquarters(customerId, callback = () => {}) {
      console.log("loading headquarters: clear");
      this.sediItems = [];
      this.sedi = [];
      console.log("loading headquarters: getAll");
      EasyPlanClient.Headquarters.GetAll(
        this.$route.params.companyAlias,
        customerId
      )
        .then((res) => {
          console.log("loading headquarters: sedi", this.sedi);
          this.sedi = res.data.data;
          for (let i = 0; i < this.sedi.length; i++) {
            let sede = this.sedi[i];
            this.sedi[i].fullAddress = this.getFullAddress(
              sede.indirizzo,
              sede.citta,
              sede.provincia
            );
            console.info("sede", sede);
            this.sediItems.push(sede.fullAddress);
          }

          console.log("loading headquarters: sediItems", this.sediItems);
          callback(this.sedi);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
</script>

<style>
.addCliente {
  margin-top: 12px;
}

.addIntervento {
  margin-top: 12px;
}
</style>